import script from "./ClaimTokens.vue?vue&type=script&setup=true&lang=ts"
export * from "./ClaimTokens.vue?vue&type=script&setup=true&lang=ts"

import "./ClaimTokens.vue?vue&type=style&index=0&id=f795730e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f795730e"]])

export default __exports__